export const fetchSettings = () => Promise.resolve({
    'version': 21,
    'enable_comment_sharing': 0,
    'enable_comment_reply': 0,
    'enable_comment_liking': 0,
    'enable_comment_flagging': 0,
    'premoderate_picture_comments': 0,
    'premoderate_video_comments': 0,
    'enable_page_rating': 0,
    'enable_locations': 0,
    'enable_location_hiding': 0,
    'enable_location_editing': 0,
    'enable_site_sections': 0,
    'lang': 'en',
    'time_zone': '-05US\/Eastern',
    'enable_page_updates': 1,
    'enable_muting': 0,
    'mute_limit': 100,
    'enable_ads': 0,
    'disable_widget_logins': 0,
    'disable_cookie_avatars': 0,
    'disable_cookie_displayname': 0,
    'client_notification_image': [],
    'viafoura_branding': 1,
    'enable_ingest_tracking': 1,
    'ingest_tracking_throttle': 100,
    'audience_insight': 0,
    'enable_tray_notifications': 0,
    'enable_push_notifications': 0,
    'client_opt_in_url': '',
    'disable_email_notifications': 0,
    'enable_recaptcha': 0,
    'recaptcha_site_key': '',
    'enable_commenting': 1,
    'enable_anonymous_comments': 1,
    'enable_realtime': 1,
    'enable_dislikes': 0,
    'comment_max_length': 1800,
    'show_more_character_limit': 500,
    'comment_thread_replies': 2,
    'enable_comment_sorting': 1,
    'review_sort': 'newest',
    'commenting_sort': 'newest',
    'enable_comment_images': 1,
    'enable_comment_video': 1,
    'max_video_duration': 60,
    'enable_user_comment_remove': 0,
    'enable_user_comment_editing': 0,
    'user_comment_edit_timeout': 300,
    'disable_comments_after_a_time': 0,
    'premoderate_text_comments': 0,
    'premoderate_media_content': 0,
    'akismet_auto_checking': 1,
    'moderation_smartmod_enabled': 1,
    'moderation_smartmod_feedback_enabled': 1,
    'moderation_smartmod_api': '',
    'moderation_smartmod_client_context': '',
    'moderation_smartmod_approve': 'open',
    'moderation_smartmod_unknown': 'open',
    'moderation_smartmod_reject': 'open',
    'moderation_smartmod_down': 'open',
    'enable_sharebar': 1,
    'sharebar_site_name': '',
    'sharebar_protocol': 'http:',
    'sharebar_twitter_via': '',
    'sharebar_twitter_related': '',
    'sharebar_twitter_hashtag': '',
    'sharebar_networks_desktop': [ 'facebook', 'twitter', 'google-plus', 'email', 'linkedin', 'pinterest', 'reddit', 'stumbleupon', 'link' ],
    'sharebar_networks_mobile': [ 'facebook', 'twitter', 'google-plus', 'whatsapp', 'email', 'linkedin', 'pinterest', 'reddit', 'stumbleupon', 'link' ],
    'enable_username_premoderation': 1,
    'enable_avatar_premoderation': 0,
    'enable_email_verification': 0,
    'authprovider_viafoura_enabled': 1,
    'authprovider_custom_cookie_name': '',
    'authprovider_backplane_v1_2_enabled': 0,
    'authprovider_backplane_v1_2_client_id': '',
    'authprovider_backplane_v2_enabled': 0,
    'authprovider_facebook_enabled': 1,
    'authprovider_facebook_client_id': '261534180557793',
    'authprovider_loginradius_enabled': 0,
    'authprovider_google_enabled': 1,
    'authprovider_google_client_id': '',
    'authprovider_linkedin_enabled': 1,
    'authprovider_linkedin_key': 's14idl50chtv',
    'authprovider_twitter_enabled': 1,
    'authprovider_twitter_key': 'FZfXQhOXrbn2qIpZ1wffDQ',
    'authprovider_yahoo_enabled': 1,
    'authprovider_yahoo_key': 'dj0yJmk9aXZWYThFOFJHWWoyJmQ9WVdrOVlXRXhUazF0Tm1zbWNHbzlNVGcxTURjNE56azJNZy0tJnM9Y29uc3VtZXJzZWNyZXQmeD0wOQ--',
    'authprovider_windowslive_enabled': 1,
    'authprovider_windowslive_client_id': '00000000480BD940',
    'authprovider_oauth_enabled': 0,
    'authprovider_oauth_display_name': 'OAuth',
    'authprovider_oauth_key': 'viafoura',
    'authprovider_oauth2_enabled': 0,
    'authprovider_oauth2_display_name': 'OAuth 2.0',
    'authprovider_oauth2_key': 'viafoura',
    'badging_trusted_display': 1,
    'badging_trusted_tag': 'Trusted',
    'badging_authoritative_display': 1,
    'badging_authoritative_tag': 'Respected',
    'badging_authoritative_days': 90,
    'badging_authoritative_likesreceived': 180,
    'badging_authoritative_repliesreceived': 20,
    'badging_connected_display': 1,
    'badging_connected_tag': 'Insightful',
    'badging_connected_days': 30,
    'badging_connected_repliesmade': 150,
    'badging_moderator_display': 1,
    'badging_moderator_tag': 'Mod',
    'badging_engaged_display': 1,
    'badging_engaged_tag': 'Attentive',
    'badging_engaged_days': 30,
    'badging_engaged_commentsmade': 150,
    'badging_engaged_likesmade': 100,
    'badging_active_display': 1,
    'badging_active_tag': 'Active',
    'badging_active_days': 7,
    'badging_active_commentsmade': 1,
    'authprovider_gigya_poll': 0,
    'defaults_version': 235,
    'site_id': 0,
    'site_uuid': '00000000-0000-4000-8000-000000000000',
    'site_group_id': 0,
    'site_group_uuid': '00000000-0000-4000-8000-000000000000',
    'section_id': 0,
    'server_time': 1509047195,
    'daylightSavings': 1,
    'authprovider_janrain_enabled': 1,
    'authprovider_janrain_endpoint': 'https://viafoura.janrain.com',
});
